import Carousel from '@carvana/ds-carousel';
import {
  CommonHeading,
  ContentContainer
} from '~/components/flp/Financing.styles';
import Section from '~/components/flp/Section';
import { appAssetsCdnUrl } from '~/constants/environment';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { BodyStyle } from '~/contracts/flp';
import VehicleCard from './VehicleCard';

const bodyStyles: BodyStyle[] = [
  {
    key: 'suv',
    displayName: 'SUVs',
    image: `${appAssetsCdnUrl}/images/flp/suv.png`
  },
  {
    key: 'sedan',
    displayName: 'Sedans',
    image: `${appAssetsCdnUrl}/images/flp/sedan.png`
  },
  {
    key: 'pickup',
    displayName: 'Trucks',
    image: `${appAssetsCdnUrl}/images/flp/truck.png`
  },
  {
    key: 'coupe',
    displayName: 'Coupes',
    image: `${appAssetsCdnUrl}/images/flp/coupe.png`
  },
  {
    key: 'minivan',
    displayName: 'Minivans',
    image: `${appAssetsCdnUrl}/images/flp/minivan.png`
  },
  {
    key: 'convertible',
    displayName: 'Convertibles',
    image: `${appAssetsCdnUrl}/images/flp/convertible.png`
  },
  {
    key: 'hatchback',
    displayName: 'Hatchbacks',
    image: `${appAssetsCdnUrl}/images/flp/hatchback.png`
  },
  {
    key: 'wagon',
    displayName: 'Wagons',
    image: `${appAssetsCdnUrl}/images/flp/wagon.png`
  }
];

export default function ShopStyles() {
  return (
    <Section
      eventName={ANALYTICS_EVENTS.PREQUALIFIED.SECTION_VIEWED_SHOPSTYLES}
    >
      <ContentContainer className="w-full">
        <Carousel
          ariaLabel="Shop by body style"
          classes={{ slides: 'gap-lg' }}
          headerContent={
            <CommonHeading className="pb-xl">Shop by body style</CommonHeading>
          }
        >
          {bodyStyles.map(bodyStyle => (
            <VehicleCard key={bodyStyle.key} bodyStyle={bodyStyle} />
          ))}
        </Carousel>
      </ContentContainer>
    </Section>
  );
}
